module.exports = __webpack_public_path__ + "static/media/logo_edis_white.f9d2ce01.svg";